import { Button } from 'antd'
import { useState } from 'react'
import { Text, Text3 } from './custom/Typography'
import WarningIcon from '../images/Action/warning.svg'
import ModalCustom from './modal-custom'
import { Image } from 'react-bootstrap'
import { updateLocationOrgs } from '../services/setting/locations/location-assign'
import AlertSuccess from '../alert/AlertSuccess'
import { useTranslation } from 'react-i18next'

const modalConfirmFooterButtonStyle = {
  background: 'var(--comp-btn-color-background-primary-normal)',
  color: 'var(--color-on-primary-content-high)',
  border: 'none',
  fontWeight: 500
}

export default function ModalApproveItem({
  open,
  onCancel,
  data,
  fnDone = () => {},
  onConfirm = null,
  cancelText = null,
  confirmText = null,
  title = null,
  subTitle = null
}) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const handleConfirmApproveAll = async () => {
    try {
      setIsLoading(true)

      if (onConfirm) {
        await onConfirm(data)
        onCancel()
        fnDone()
        return
      }

      const body = {
        org_id: data.org_id,
        assign: Array.isArray(data.assign) ? data.assign : [],
        unassign: Array.isArray(data.unassign) ? data.unassign : []
      }

      const res = await updateLocationOrgs({}, body)

      if (res?.success) {
        AlertSuccess(t('hrms_setting_location_success_toast'))
        onCancel()
        fnDone()
      }
    } catch (err) {
      console.error('Update location org error:', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <ModalCustom
      centered
      closable={false}
      open={open}
      onCancel={onCancel}
      title={null}
      width={391}
      footer={
        <div className="d-flex gap-4 mt-5 justify-content-center w-100">
          <Button
            disabled={isLoading}
            style={{
              width: '50%',
              height: 40,
              borderColor: 'var(--color-on-base-border-default, #E6E9F5)',
              fontWeight: 500
            }}
            onClick={onCancel}
          >
            {cancelText ?? 'cancel'}
          </Button>
          <Button
            disabled={isLoading}
            type="primary"
            style={{
              width: '50%',
              height: 40,
              ...modalConfirmFooterButtonStyle
            }}
            onClick={handleConfirmApproveAll}
          >
            {confirmText ?? 'confirm'}
            {isLoading && '...'}
          </Button>
        </div>
      }
    >
      <div className="d-flex flex-column align-items-center text-center">
        <div
          style={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'var(--color-primary-foreground-subtle-hover)',
            color: 'var(--color-primary-content-default)'
          }}
          className="d-inline-flex  align-items-center justify-content-center"
        >
          <Image src={WarningIcon} width={74} height={74} alt="warning" />
        </div>
        <Text3 size="20px" className="mt-3">
          {title ?? 'Are you sure?'}
        </Text3>
      </div>
      <Text size="16px" className="text-center mt-2">
        {subTitle ?? 'Do you want to proceed with this action?'}
      </Text>
    </ModalCustom>
  )
}
